import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadTemplateHelperDataFailed, loadTemplateHelperDataSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadTemplateHelperData(action) {
  try {
    const url = `${BACKEND_URL}/resources/notification-templates/template-helper`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    const data = yield dataResponse?.json();
    if (dataResponse?.status === OK) {
      yield put(loadTemplateHelperDataSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadTemplateHelperDataFailed());
      yield call(rejectActionPromise(action, data?.data));
    }
  } catch (e) {
    yield put(loadTemplateHelperDataFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
